import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  palette: {
    background: {
      main: '#f9f9f9'
    }
  },
});